import React, { useState, useEffect } from 'react'
import Dialog from '../../GenericComponents/dialog' // Adjust the import path as needed
import { useGetDBVisualUnitsMutation } from '../../Redux/Workspace/workspaceActionsSlice'

import HLServerSearchListDialog from '../../GenericComponents/hlServerSearchListDialog'
import { attachExistingReportsCallback } from '../../GenericComponents/attachExistingReportsCallback'

interface AttachExistingVUDialogProps {
    isOpen: boolean
    onClose: () => void
    WorkspaceId: number
    wsid: string
}

const AttachExistingVUDialog: React.FC<AttachExistingVUDialogProps> = ({
    isOpen,
    onClose,
    wsid,
    WorkspaceId,
}) => {
    const [attachExistingElement, setAttachExistingElement] = useState('')
    const [getDBVisualUnits] = useGetDBVisualUnitsMutation()

    useEffect(() => {
        if (isOpen) {
            showAttachExistingVisualUnitDialog()
        }
    }, [isOpen])

    const showAttachExistingVisualUnitDialog = async () => {
        const elementObjAttachExistingVU = await handleGetDBVisualUnits(wsid)
        setAttachExistingElement(elementObjAttachExistingVU)
    }
    const handleGetDBVisualUnits = (dashBoardId: string) => {
        return getDBVisualUnits(dashBoardId)
            .unwrap()
            .then((response: any) => {
                if (response?.statusCode === 200) {
                    const resultData = response.data
                    if (resultData && resultData.length > 0) {
                        const formattedUnits = resultData.map((item: any) => ({
                            DisplayText: item.name,
                            KeyValue: item.id,
                            isSoftwareRestricted: !!(
                                item.dashboardAppGuid && item.visualUnitAppGuid
                            ),
                        }))
                        return formattedUnits
                    } else {
                        return []
                    }
                } else {
                    console.error('Failed to get visual units for this dashboard.')
                    return []
                }
            })
            .catch((error: any) => {
                console.error('Error fetching visual units:', error)
                return []
            })
    }

    return (
        <HLServerSearchListDialog
            elementObj={attachExistingElement}
            onClose={onClose}
            isOpen={isOpen}
            callbacks={attachExistingReportsCallback(WorkspaceId)}
        ></HLServerSearchListDialog>
    )
}

export default AttachExistingVUDialog
